import useAuth from '../auth/useAuth';

// Surveys a Client-role user may see, mirroring the SurveyClient rows the
// backend consults in authorization/views.py:requires_survey_scope.
export default function usePermissionedSurveyIds() {
  const { user, isLoading } = useAuth();
  return { surveyIds: user?.survey_ids ?? [], isLoading };
}
